/* eslint-disable @nx/enforce-module-boundaries */
import { forwardRef, useContext } from 'react';
import { GlobalContext } from '../context';
import { ImagePopup } from 'v4/components/image-popup';
export const GlobalImagePopup = forwardRef(({ ...props }, ref) => {
  const { image, imagePopupDisc } = useContext(GlobalContext);
  return <ImagePopup src={image} {...imagePopupDisc} />;
});
